import React, { useState } from "react";

import Steps from "../../ui_atoms/Steps";
import VStack from "../../ui_atoms/VStack";
import { Button, View, Text } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";

function StepsStoryComponent() {
    const [index, setIndex] = useState(5);
    return (
        <VStack
            gap={0.5}
            h={1}
            style={{
                alignSelf: "stretch",
            }}
            alignment="center"
        >
            <Steps count={10} index={index} />
            <Steps
                stepsInfo={[
                    { isVisible: false },
                    { isVisible: true },
                    { isVisible: false },
                    { isVisible: true },
                    { isVisible: true },
                    { isVisible: false },
                    { isVisible: true },
                    { isVisible: true },
                    { isVisible: true },
                    { isVisible: false },
                ]}
                index={index}
                stepsConfig={{
                    seenColor: "red",
                }}
            />
            <Text>Index: {index}</Text>
            <View style={{ flexDirection: "row" }}>
                <Button
                    title="-"
                    onPress={() => {
                        void setIndex((idx) => {
                            return Math.max(0, idx - 1);
                        });
                    }}
                />
                <Button
                    title="+"
                    onPress={() => {
                        void setIndex((idx) => {
                            return Math.min(9, idx + 1);
                        });
                    }}
                />
            </View>
        </VStack>
    );
}

const meta = {
    title: "Atom/Steps",
    component: StepsStoryComponent,
    argTypes: {},
} satisfies Meta<typeof StepsStoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {},
};
